import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { OKGeneric, PusherEventNamesSchema } from '../models';

extendZodWithOpenApi(z);
const c = initContract();

/**
 * Paths
 */
export const apiPusher = c.router({
  pusherUserAuthenticate: {
    method: 'POST',
    path: `/1.0/pusher/user-auth`,
    description: `Authenticates a user with Pusher to secure the connection.`,
    body: z.object({
      socket_id: z.string().openapi({ description: 'The socket id from Pusher' }),
    }),
    responses: {
      200: z.object({
        auth: z.string().openapi({
          description: 'The authentication string',
          example: 'e0456d61af3bd230a12:86d6f418a3f32f2341163ea858b516c8b24f98ab23f4f1aa976ed0a6d',
        }),
        user_data: z.string().openapi({
          description: 'The user data in a JSON encoded string',
          example: '{"id":"40aa5a5d-ef03-4b12-55c5-4123b32e38dc","user_info":{}}',
        }),
      }),
    },
  },
  pusherChannelAuthorize: {
    method: 'POST',
    path: `/1.0/pusher/channel-auth`,
    description: `Authorizes a user to connect to a channel.`,
    body: z.object({
      socket_id: z.string().openapi({ description: 'The socket id from Pusher' }),
      channel_name: z.string().openapi({ description: 'The channel name to authorize' }),
    }),
    responses: {
      200: z.object({
        auth: z.string().openapi({
          description: 'The authorization string',
          example: 'e0456d61af3bd230a12:86d6f418a3f32f2341163ea858b516c8b24f98ab23f4f1aa976ed0a6d',
        }),
      }),
    },
  },
  proxyPusherMessage: {
    method: 'POST',
    path: `/1.0/pusher/proxy-dispatch`,
    description:
      'Proxy endpoint for triggering arbitrary Pusher events /w payload, most used in testing context. `payload` is NOT type-checked/validated.',
    body: z.object({
      channel_name: z.string().openapi({
        example: 'private-USER_ID',
        description: 'The channel name to dispatch the event to',
      }),
      event_name: PusherEventNamesSchema,
      payload: z
        .object({})
        .passthrough()
        .or(z.string())
        .optional()
        .openapi({ description: 'The payload to dispatch' }),
    }),
    responses: {
      200: OKGeneric,
    },
  },
});
